// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Wy5Z","badges":"styles_badges__21wSX"};